import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { GroupAccess, GroupAccessCandidate, GroupAccessGrantRequest } from '../interfaces/intercompany.interface';

const E = ENDPOINTS.INSTITUTION_GROUP_ACCESS;

/** Give a user of one group company a role in a sister group company (additive; revoke removes only that grant). */
export const GroupAccessService = {
  list: async (institutionId: string): Promise<GroupAccess[]> => (await axios.get(E.LIST(institutionId))).data,
  candidates: async (institutionId: string): Promise<GroupAccessCandidate[]> => (await axios.get(E.CANDIDATES(institutionId))).data,
  grant: async (body: GroupAccessGrantRequest): Promise<GroupAccess> => (await axios.post(E.GRANT, body)).data,
  revoke: async (institutionId: string, membershipId: string): Promise<void> => { await axios.delete(E.REVOKE(institutionId, membershipId)); },
};
